import axios from 'axios'
import { transformDates } from './axiosDateTransformer'

const apiClient = axios.create({})

if (process.env.NODE_ENV === 'development') {
  console.debug('Development mode: Adding artificial delay to API requests')
  // Add artificial delay to simulate network latency
  apiClient.interceptors.response.use(async (response) => {
    // Generate random delay between 0.1 and 1 seconds
    const delay = Math.random() * 600 + 50
    await new Promise((resolve) => setTimeout(resolve, delay))
    return response
  })
}

// Add date transformation interceptor
apiClient.interceptors.response.use((response) => transformDates(response))

export default apiClient
